import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 3.967A.667.667 0 0 0 6 5.3h4a.667.667 0 0 0 0-1.333zM5.333 7.3c0-.368.299-.667.667-.667h4a.667.667 0 0 1 0 1.334H6a.667.667 0 0 1-.667-.667M6 9.3a.667.667 0 0 0 0 1.333h2.667a.667.667 0 0 0 0-1.333z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.667 1.3a2 2 0 0 0-2 2v9.333a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V3.3a2 2 0 0 0-2-2zm-.472 1.529a.67.67 0 0 1 .472-.196h6.666A.667.667 0 0 1 12 3.3v9.333a.667.667 0 0 1-.667.667H4.667A.667.667 0 0 1 4 12.633V3.3c0-.177.07-.346.195-.471",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })